export default "__VITE_ASSET__Biohe49R__"